import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import FileUploadButton from '../../common/formComponents/fileUploadButton';
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AdminStudyUpdateDocument = (props) => {
    const [message, setMessage] = useState('');

    const handleDownload = () => {
        const fileUrl = `https://himalayas-space.nyc3.cdn.digitaloceanspaces.com/${props.folderPath}${props.fileName}`;
        window.open(fileUrl, '_blank');
    };

    return ( 
        <StyledContainer>
            <Row style={{ display:'flex', flexDirection:'row', alignItems: 'center'}}>
                <Col xs='3'>
                    <h5>{props.title}</h5>
                </Col>
                <Col>
                    <FileUploadButton folderPath={props.folderPath} fileName={props.fileName} updateMessage={setMessage}/>
                </Col>
                <Col xs='2'>
                    <StyledButton onClick={handleDownload} color="primary">
                        <FAIconButton icon={["fas", "download"]}></FAIconButton>
                        Download
                    </StyledButton>
                </Col>
                <Col xs='3'>
                    <StatusMessage>{message}</StatusMessage>
                </Col>
            </Row>
        </StyledContainer>
    );
}
 
export default AdminStudyUpdateDocument;

const StyledContainer = styled(Container)`
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;

    &:hover {
        background-color: #e9ecef;
    }
`;

const StyledButton = styled(Button)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 120px;
`;

const FAIconButton = styled(FontAwesomeIcon)`
    margin-right: 4px;
`;

const StatusMessage = styled.p`
    margin: 0;
    color: ${props => props.children.includes('success') ? '#28a745' : props.children.includes('Error') ? '#dc3545' : '#6c757d'};
    font-size: 0.9em;
`;
